import unsavedChanges from './unsavedChanges.js';
import handleError from './handleError.js';
import isCharacterKeyPress from './isCharacterKeyPress.js';
import getOffset from './getOffset.js';
import getScrollbarSize from './getScrollbarSize.js';

const ui = {
  getScrollbarSize,
  getOffset,
  isCharacterKeyPress,
  handleError,
};

export default ui;
